import type * as FirebaseAuth from "firebase/auth"
import type { DefaultLookId, UserDocument } from "popopo-msg"
import { useForm } from "react-hook-form"
import { api, firestore } from "../../core"
import { useDefaultLooks } from "popopo-lib-front/firestore-access"
import { SpinnerRow } from "../SpinnerRow"

type UserLookForms = {
  id: DefaultLookId
}

export const UserLookForm = (props: { firebase: FirebaseAuth.User; user: UserDocument }) => {
  const looks = useDefaultLooks(firestore)
  const form = useForm<UserLookForms>({
    mode: "onBlur",
  })
  const { isSubmitting, isValid } = form.formState

  const onSubmit = async (value: UserLookForms) => {
    try {
      const idToken = await props.firebase.getIdToken()
      await api.PUT("/api/v2/users/me/profile/look", {
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: {
          id: value.id,
          kind: "DefaultLook",
          customize: {
            eyeColor: 1,
            skinColor: 1,
          },
        },
      })
    } catch (e) {
      console.error(e)
    }
  }

  if (looks === "loading") {
    return <SpinnerRow/>
  }

  return (
    <form className="d-flex w-100 flex-column gap-3" onSubmit={form.handleSubmit(onSubmit)}>
      <div className="form-floating">
        <select className="form-control" disabled={isSubmitting} {...form.register("id")}>
          {looks.map((look) => (
            <option key={look.id} value={look.id}>
              {look.name}
            </option>
          ))}
        </select>
        <label>Kind</label>
      </div>

      <button type="submit" className="btn btn-primary form-control" disabled={isSubmitting || !isValid}>
        Submit
      </button>
    </form>
  )
}
